import React from "react";
import { useSelector } from "react-redux";
import moment from "moment";
import TruncateTest from "../../common/TruncateTest";

const AboutCompany = () => {
  const companyDetails = useSelector(
    (state) => state.companyDetailsReducer.companyDetails
  );


  return (
    <div className="common-box-2 row mb-2 py-20 px-2 heading13px roboto-regular">
      <div className="row c-details w-100- ">
        <div className="col mt-3 w-col-3 mb20">
          <div className="roboto-regular d-flex align-items-center">
            <i className="text-black heading18px la la-users mr-2"></i>
            <span className="font-weight-bold">Employees Range</span>
          </div>
          <div className="gap-l">{companyDetails?.range?.name}</div>
        </div>

        <div className="col mt-3 w-col-3 mb20">
          <div className="d-flex align-items-center">
            <i className="heading18px  text-black las la-money-check mr-2"></i>
            <span className="font-weight-bold">Revenue Range</span>
          </div>
          <div className="gap-l">{companyDetails?.revenue?.name}</div>
        </div>

        <div className="col mt-3 w-col-3 mb20">
          <div className="d-flex align-items-center">
            <i
              className="heading18px text-black la la-city mr-2"
              aria-hidden="true"
            ></i>
            <span className="font-weight-bold">Company Type</span>
          </div>
          <div className="gap-l">{companyDetails?.category?.name}</div>
        </div>
      </div>

      <div className="row c-details w-100-">
        <div className="col mt-3 w-col-3 mb20">
          <div className="d-flex align-items-center">
            <i className="heading18px text-black las la-industry mr-2"></i>
            <span className="font-weight-bold">Industry</span>
          </div>
          <div className="gap-l">{companyDetails?.industry?.name}</div>
        </div>

        <div className="col mt-3 w-col-3 mb20">
          <div className="d-flex align-items-center">
            <i className=" mr-2 text-black heading18px  las la-cog"></i>
            <span className="font-weight-bold">Technographics</span>
          </div>
          <div className="gap-l">{companyDetails?.technographics}</div>
        </div>

        <div className="col mt-3 w-col-3 mb20">
          <div className="d-flex align-items-center">
            <i className=" mr-2 text-black heading18px las la-calendar"></i>
            <span className="font-weight-bold">Updated on</span>
          </div>
          <div className="gap-l">
            {moment(companyDetails?.lastUpdated).format("D MMMM YYYY, h:mm a")}
          </div>
        </div>
      </div>

      <div className="row mt-3 w-100-">
        <div className="col w-col-9" style={{ maxWidth: "96.3%" }}>
          <div className="d-flex align-items-center">
            <i className="heading18px text-black las la-suitcase mr-2"></i>
            <span className="font-weight-bold">Product and Services</span>
          </div>
          <div className="gap-l">
            <TruncateTest description={companyDetails?.productServices} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutCompany;
